export interface MexicanState {
  id: string;
  name: string;
  code: string;
}

export const MEXICAN_STATES: MexicanState[] = [
  { id: "69a9e61a9bd8bf6b1c5d54a1", name: "Aguascalientes", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d54ad", name: "Baja California", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d54b5", name: "Baja California Sur", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d54bb", name: "Campeche", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d54c9", name: "Chiapas", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5546", name: "Chihuahua", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d558a", name: "Ciudad de México", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d559b", name: "Coahuila de Zaragoza", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d55c2", name: "Colima", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d55cd", name: "Durango", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d55f5", name: "Estado de México", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d560a", name: "Guanajuato", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5639", name: "Guerrero", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d568f", name: "Hidalgo", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d56e4", name: "Jalisco", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5762", name: "Michoacán de Ocampo", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d57d4", name: "Morelos", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d57f9", name: "Nayarit", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d580e", name: "Nuevo León", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5842", name: "Oaxaca", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5a7d", name: "Puebla", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5b57", name: "Querétaro", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5b6a", name: "Quintana Roo", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5b76", name: "San Luis Potosí", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5bb1", name: "Sinaloa", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5bc6", name: "Sonora", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5c0f", name: "Tabasco", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5c21", name: "Tamaulipas", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5c4d", name: "Tlaxcala", code: "MX" },
  { id: "69a9e61a9bd8bf6b1c5d5c8a", name: "Veracruz de Ignacio de la Llave", code: "MX" },
  { id: "69a9e61b9bd8bf6b1c5d5d5f", name: "Yucatán", code: "MX" },
  { id: "69a9e61b9bd8bf6b1c5d5dca", name: "Zacatecas", code: "MX" },
];